"use strict";

var Qs = require('qs');

module.exports = {
  name: 'rails-params-serializer',
  req: function req(payload) {
    if (payload.req.method === 'GET') {
      payload.req.paramsSerializer = {
        serialize: function serialize(params) {
          return Qs.stringify(params, {
            arrayFormat: 'brackets',
            encodeValuesOnly: true
          });
        }
      };
    }

    return payload;
  }
};